import { Injectable } from '@angular/core';
import { userDtos, webDtos } from '@vectronic/openApi-customer';
import { Observable, of } from 'rxjs';
import { EventRequestDto } from '../../genericHelp/event.help';
import { MatDialogMock } from '../components/mat-dialog.mock';

@Injectable()
export class AnimalServiceMock {
  deletedAnimals$ = of(undefined);
  filter$ = of(undefined);
  animals$: Observable<
    (webDtos.AnimalExtended & { groups: userDtos.Group[] } & {
      currentCollar: webDtos.CollarExtended;
    })[]
  > = of(undefined);
  animalsPage$: Observable<
    (webDtos.AnimalExtended & { groups: userDtos.Group[] } & {
      currentCollar: webDtos.CollarExtended;
    })[]
  > = of(undefined);
  animalsCount$: Observable<number> = of(undefined);
  request$: Observable<EventRequestDto> = of(undefined);

  dialog = new MatDialogMock();

  createShare() {}

  shareAnimal() {}

  editAnimal() {}

  isOwnerOfAllSelectedAnimals() {
    return false;
  }

  isOwnerOfAtLeastOneSelectedAnimals() {
    return false;
  }

  isAdminOrOwnerOfAllSelectedAnimals() {
    return false;
  }

  deleteAnimals() {}

  openCreateAnimalModal() {}

  private filterAnimals() {
    return of(undefined);
  }

  changePage() {}

  onGroupSelected() {}

  onSearchTermChanged() {}

  onSortTable() {}

  unsubscribeAnimal() {}

  private unsubscribeFromCollar() {}

  unsubscribeSelectedAnimals() {}

  getUserShare(): Observable<userDtos.Share> {
    return of(undefined);
  }
}
